import { render, staticRenderFns } from "./WizardHandoffStep.vue?vue&type=template&id=c76de212&scoped=true"
import script from "./WizardHandoffStep.vue?vue&type=script&lang=js"
export * from "./WizardHandoffStep.vue?vue&type=script&lang=js"
import style0 from "./WizardHandoffStep.vue?vue&type=style&index=0&id=c76de212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76de212",
  null
  
)

export default component.exports